<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="t('modalsConfirmAddressTitle')"
      [size]="'medium'"
      [showCloseButton]="false"
      [isLoading]="isLoading()"
      [ariaLabelledBy]="'confirm-address-modal-title'"
      (closeModal)="onCancel()"
    >
      <div modal-content>
        <p id="confirm-address-modal-message" class="text-body text-ld-neutral-500 text-center mb-4">
          {{ t('modalsConfirmAddressMessage') }}
        </p>

        <div id="confirm-address-modal-address" class="bg-ld-neutral-50 rounded-lg p-4 text-center">
          <p class="font-dm text-base text-ld-neutral whitespace-pre-line leading-relaxed">
            {{ formattedAddress }}
          </p>
        </div>
      </div>

      <div modal-footer>
        <button
          id="confirm-address-modal-confirm-btn"
          type="button"
          class="btn-primary-ld-purple"
          [disabled]="isLoading()"
          (click)="onConfirm()"
        >
          @if (isLoading()) {
            <mat-spinner diameter="16" class="w-4! h-4!"></mat-spinner>
          }
          {{ t('modalsConfirmAddressConfirmButton') }}
        </button>

        <button
          id="confirm-address-modal-cancel-btn"
          type="button"
          class="btn-outline-ld-purple"
          [disabled]="isLoading()"
          (click)="onCancel()"
        >
          {{ t('commonButtonsCancel') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
